import {
  Flex,
  Heading,
  Stack,
  SvgCaretLeft,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { RouterLink } from 'src/components/RouterLink/RouterLink';

export interface MealCreditTitleProps {
  corpId: string;
  title: string;
}

export function MealCreditTitle({
  corpId,
  title,
}: MealCreditTitleProps): JSX.Element {
  return (
    <Flex alignItems="center">
      <Stack x="xx-sm">
        <RouterLink href={`/corporate/enterprise/${corpId}/meal-credits`}>
          <SvgCaretLeft
            size="24px"
            aria-label="Go back to meal credit list page"
          />
        </RouterLink>
      </Stack>
      <Heading variant="h1">{title}</Heading>
    </Flex>
  );
}
